import React from 'react';
//import { Button } from '../../../third-party-components/material-ui';
//import Button from '@mui/material/Button'

const AssessmentContentActionButton = ({children, onClick, selected = false, styleType = ""}) => (
    onClick != undefined ? <button color="primary" onClick={onClick} className={"assessment-content-action-button " + styleType} style={{ textTransform: "none" }}>{children}</button> : null
)

export default AssessmentContentActionButton;

